<template>
  <div>
    <div class="filter"
         :style="{right:position.right+'px',bottom:position.bottom+'px'}"
         ref="homeicon"
         @click="filterBnt"></div>

  </div>
</template>
<script>
//   import bus from '../bus/index'
export default {
  data () {
    return {
      position: {
        right: '10',
        bottom: '100'
      },
      clientX: '',
      clientY: ''

    }
  },
  props: {},
  methods: {
    filterBnt () {
      alert(2)
      this.$emit('filterBnt')
    },
    touchstart (ev) {

      let event = ev || window.event;
      //   event.preventDefault()
      let pageX =
        event.targetTouches[0].clientX + document.documentElement.scrollLeft;
      let pageY =
        event.targetTouches[0].clientY + document.documentElement.scrollTop;
      let homeicon = this.$refs.homeicon;
      let wrapper = document.getElementsByClassName('con_view')[0]
      this.clientX = window.screen.width;
      this.clientY = window.screen.height;

      this.position = {
        right: this.clientX - (pageX + homeicon.offsetWidth / 2),
        bottm: this.clientY - (pageY + homeicon.offsetHeight / 2)
      };
      // console.log(this.position)
    },
    touchMove (ev) {
      let homeicon = this.$refs.homeicon;
      let wrapper = document.getElementsByClassName('con_view')[0]

      let event = ev || window.event;
      let pageX =
        event.targetTouches[0].clientX + document.documentElement.scrollLeft;
      let pageY =
        event.targetTouches[0].clientY + wrapper.scrollTop;
      //   event.preventDefault()
      let right = this.clientX - (pageX + homeicon.offsetWidth / 2);
      let bottom = this.clientY - (pageY + homeicon.offsetHeight / 2);
      let maxRight = this.clientX - homeicon.offsetWidth;
      let maxBottom = this.clientY - homeicon.offsetWidth;

      if (right <= 0) {
        right = 0;
      }
      if (right >= maxRight) {
        right = maxRight;
      }
      if (bottom <= 0) {
        bottom = 0;
      }
      if (bottom >= maxBottom) {
        bottom = maxBottom;
      }
      this.position = {
        right: right,
        bottom: bottom
      };
    },

  },

  computed: {},
  mounted () {


  }
}
</script>
<style scoped lang="scss">
.filter {
  position: fixed;
  bottom: 1.21rem;
  right: 0.32rem;
  width: 0.86rem;
  height: 0.86rem;
  border-radius: 50%;
  // background:linear-gradient(0deg,rgba(9,131,255,1) 0%,rgba(2,106,212,1) 100%);
  z-index: 3;
  background: url("../../assets/images/shaixuan.png") no-repeat;
  background-size: 100% 100%;
  z-index: 999999;
}
</style>



// WEBPACK FOOTER //
// src/components/container/filterBnt.vue